export default __webpack_public_path__ + "static/media/plus-circle.615f761f.svg";